import _toConsumableArray from "/var/lib/jenkins/workspace/minasidor.salabostader.se/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
import React, { useEffect, memo } from "react";
import clsx from "clsx";
import { visuallyHidden } from "../utils/styles.module.css";
import * as defaultStyles from "./Link.module.css";
import withComponentDefaults from "../utils/withComponentDefaults";
import { useURLTransformer } from "../hooks";
import { filterAttributes } from "../utils";
import Icon from "./Icon";
function upperFirst(string) {
  return string[0].toUpperCase() + string.slice(1);
}
function getURLType(url) {
  if (url.startsWith("#")) {
    return "anchor";
  }
  try {
    var _URL = new URL(url),
      protocol = _URL.protocol,
      hostname = _URL.hostname;
    if (protocol && protocol !== "http:" && protocol !== "https:") {
      return protocol.substr(0, protocol.length - 1);
    }
    if (hostname) {
      return "external";
    }
  } catch (_unused) {}
  return "internal";
}
export default memo(withComponentDefaults(Link, "link"));
function Link(_a) {
  var _b = _a,
    as = _b.as,
    _b$components = _b.components,
    _c = _b$components === void 0 ? {
      ButtonElement: "button",
      InertElement: "span",
      LabelElement: "label",
      DefaultElement: "a"
    } : _b$components,
    _d = _c,
    _d$ButtonElement = _d.ButtonElement,
    ButtonElement = _d$ButtonElement === void 0 ? "button" : _d$ButtonElement,
    _d$InertElement = _d.InertElement,
    InertElement = _d$InertElement === void 0 ? "span" : _d$InertElement,
    _d$LabelElement = _d.LabelElement,
    LabelElement = _d$LabelElement === void 0 ? "label" : _d$LabelElement,
    _d$DefaultElement = _d.DefaultElement,
    DefaultElement = _d$DefaultElement === void 0 ? "a" : _d$DefaultElement,
    components = __objRest(_d, ["ButtonElement", "InertElement", "LabelElement", "DefaultElement"]),
    _e = _b,
    children = _e.children,
    className = _e.className,
    href = _e.href,
    htmlFor = _e.htmlFor,
    innerRef = _e.innerRef,
    onClick = _e.onClick,
    rel = _e.rel,
    _e$styles = _e.styles,
    styles = _e$styles === void 0 ? defaultStyles : _e$styles,
    target = _e.target,
    to = _e.to,
    type = _e.type,
    uri = _e.uri,
    url = _e.url,
    _e$showExternalIcon = _e.showExternalIcon,
    showExternalIcon = _e$showExternalIcon === void 0 ? true : _e$showExternalIcon,
    restProps = __objRest(_e, ["as", "components", "children", "className", "href", "htmlFor", "innerRef", "onClick", "rel", "styles", "target", "to", "type", "uri", "url", "showExternalIcon"]);
  href = href != null && href !== "" ? href : to != null && to !== "" ? to : url != null && url !== "" ? url : uri != null && uri !== "" ? uri : null;
  var transformURL = useURLTransformer();
  href = transformURL(href);
  type = type || (htmlFor ? "label" : href != null ? getURLType(href) : onClick ? "button" : "inert");
  var Component = as || type === "inert" && InertElement || type === "label" && LabelElement || type === "submit" && (components["SubmitButtonElement"] || ButtonElement) || type === "reset" && (components["ResetButtonElement"] || ButtonElement) || type === "button" && ButtonElement || components[upperFirst(type) + "LinkElement"] || DefaultElement;
  if (target === "_blank") {
    rel = _toConsumableArray(new Set([].concat(_toConsumableArray(rel ? rel.split(/\s+/g) : []), ["noopener", "noreferrer"]))).join(" ");
  }
  var attributes = typeof Component === "string" ? filterAttributes(restProps) : restProps;
  return /* @__PURE__ */React.createElement(Component, __spreadProps(__spreadValues({
    href: href,
    onClick: onClick,
    htmlFor: htmlFor,
    className: clsx(className, styles.component, styles[type]),
    target: target,
    rel: rel,
    type: type === "button" || type === "submit" || type === "reset" ? type : void 0
  }, attributes), {
    ref: innerRef
  }), children, target === "_blank" && /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement("span", {
    className: visuallyHidden
  }, "\xD6ppnas i nytt f\xF6nster"), showExternalIcon && /* @__PURE__ */React.createElement(Icon, {
    name: "external",
    className: clsx(styles.icon)
  })));
}